import React from 'react';
import SVG from './SVGWrapper';
import { SVGProps } from '@repo/utils/types';

export const HighNetworkStrengthIcon = ({ width = 18, height = 18, ...props }: SVGProps) => (
  <SVG {...{ ...props, width, height }} className={props.className} viewBox="0 0 24 24">
    <defs>
      <linearGradient id="relationship-strength-strongest-a" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#4A90E2"></stop>
        <stop offset="100%" stopColor="#35B5FF"></stop>
      </linearGradient>
      <linearGradient id="relationship-strength-strongest-b" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#4A90E2"></stop>
        <stop offset="100%" stopColor="#35B5FF"></stop>
      </linearGradient>
      <linearGradient
        id="relationship-strength-strongest-c"
        x1="50%"
        x2="50%"
        y1="-47.082%"
        y2="117.312%"
      >
        <stop offset="0%" stopColor="#4A90E2"></stop>
        <stop offset="100%" stopColor="#35B5FF"></stop>
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(3 5.64)">
      <path
        stroke="url(#relationship-strength-strongest-a)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M2.64 0a8.98 8.98 0 000 12.723m12.722-.003A8.958 8.958 0 0018 6.36 8.958 8.958 0 0015.362 0"
      ></path>
      <path
        stroke="url(#relationship-strength-strongest-b)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M5.463 2.82A4.998 4.998 0 004 6.36c0 1.38.56 2.631 1.465 3.536m7.07 0A4.984 4.984 0 0014 6.36c0-1.382-.56-2.633-1.467-3.538"
      ></path>
      <circle
        cx="9"
        cy="6.36"
        r="2"
        strokeWidth="0"
        fill="url(#relationship-strength-strongest-c)"
      ></circle>
    </g>
  </SVG>
);

export const MediumNetworkStrengthIcon = ({ width = 18, height = 18, ...props }: SVGProps) => (
  <SVG {...{ ...props, width, height }} className={props.className} viewBox="0 0 24 24">
    <defs>
      <linearGradient
        id="relationship-strength-strong-a"
        x1="233.695%"
        x2="0%"
        y1="264.625%"
        y2="50%"
      >
        <stop offset="0%" stopColor="#FFE550"></stop>
        <stop offset="32.411%" stopColor="#FFD34F"></stop>
        <stop offset="77.106%" stopColor="#FFAE33"></stop>
        <stop offset="100%" stopColor="#FF7233"></stop>
      </linearGradient>
      <linearGradient
        id="relationship-strength-strong-c"
        x1="233.695%"
        x2="0%"
        y1="265.093%"
        y2="50%"
      >
        <stop offset="0%" stopColor="#FFE550"></stop>
        <stop offset="32.411%" stopColor="#FFD34F"></stop>
        <stop offset="77.106%" stopColor="#FFAE33"></stop>
        <stop offset="100%" stopColor="#FF7233"></stop>
      </linearGradient>
      <linearGradient
        id="relationship-strength-strong-e"
        x1="600.654%"
        x2="-46.484%"
        y1="950.252%"
        y2="50%"
      >
        <stop offset="0%" stopColor="#FFE550"></stop>
        <stop offset="32.411%" stopColor="#FFD34F"></stop>
        <stop offset="61.953%" stopColor="#FFAE33"></stop>
        <stop offset="100%" stopColor="#FF7233"></stop>
      </linearGradient>
      <filter
        id="relationship-strength-strong-b"
        width="111.1%"
        height="115.7%"
        x="-5.6%"
        y="-7.9%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic"></feGaussianBlur>
      </filter>
      <filter
        id="relationship-strength-strong-d"
        width="120%"
        height="128.3%"
        x="-10%"
        y="-14.1%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(3 5.64)">
      <path
        stroke="url(#relationship-strength-strong-a)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M2.64 0a8.98 8.98 0 000 12.723m12.722-.003A8.958 8.958 0 0018 6.36 8.958 8.958 0 0015.362 0"
        filter="url(#relationship-strength-strong-b)"
        opacity="0.25"
      ></path>
      <path
        stroke="url(#relationship-strength-strong-c)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M5.463 2.82A4.998 4.998 0 004 6.36c0 1.38.56 2.631 1.465 3.536m7.07 0A4.984 4.984 0 0014 6.36c0-1.382-.56-2.633-1.467-3.538"
        filter="url(#relationship-strength-strong-d)"
      ></path>
      <circle
        cx="9"
        cy="6.36"
        r="2"
        strokeWidth="0"
        fill="url(#relationship-strength-strong-e)"
        fillRule="nonzero"
      ></circle>
    </g>
  </SVG>
);

export const LowNetworkStrengthIcon = ({ width = 18, height = 18, ...props }: SVGProps) => (
  <SVG {...{ ...props, width, height }} className={props.className} viewBox="0 0 24 24">
    <defs>
      <linearGradient id="relationship-strength-weak-a" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#EB4D51"></stop>
        <stop offset="100%" stopColor="#FF2038"></stop>
      </linearGradient>
      <linearGradient id="relationship-strength-weak-c" x1="50%" x2="50%" y1="0%" y2="100%">
        <stop offset="0%" stopColor="#EB4D51"></stop>
        <stop offset="100%" stopColor="#FF2038"></stop>
      </linearGradient>
      <linearGradient id="relationship-strength-weak-e" x1="50%" x2="50%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#EB4D51"></stop>
        <stop offset="100%" stopColor="#FF2038"></stop>
      </linearGradient>
      <filter
        id="relationship-strength-weak-b"
        width="111.1%"
        height="115.7%"
        x="-5.6%"
        y="-7.9%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic"></feGaussianBlur>
      </filter>
      <filter
        id="relationship-strength-weak-d"
        width="120%"
        height="128.3%"
        x="-10%"
        y="-14.1%"
        filterUnits="objectBoundingBox"
      >
        <feGaussianBlur in="SourceGraphic"></feGaussianBlur>
      </filter>
    </defs>
    <g fill="none" fillRule="evenodd" transform="translate(3 5.64)">
      <path
        stroke="url(#relationship-strength-weak-a)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M2.64 0a8.98 8.98 0 000 12.723m12.722-.003A8.958 8.958 0 0018 6.36 8.958 8.958 0 0015.362 0"
        filter="url(#relationship-strength-weak-b)"
        opacity="0.16"
      ></path>
      <path
        stroke="url(#relationship-strength-weak-c)"
        strokeLinecap="round"
        strokeWidth="2"
        d="M5.463 2.82A4.998 4.998 0 004 6.36c0 1.38.56 2.631 1.465 3.536m7.07 0A4.984 4.984 0 0014 6.36c0-1.382-.56-2.633-1.467-3.538"
        filter="url(#relationship-strength-weak-d)"
        opacity="0.25"
      ></path>
      <circle
        cx="9"
        cy="6.36"
        r="2"
        strokeWidth="0"
        fill="url(#relationship-strength-weak-e)"
        fillRule="nonzero"
      ></circle>
    </g>
  </SVG>
);

const MissingNetworkStrengthIcon = () => null;
export const networkStrengthIconForBucket = (
  bucket: number,
): ((props: SVGProps) => JSX.Element) => {
  switch (bucket) {
    case 1:
      return HighNetworkStrengthIcon;
    case 2:
      return MediumNetworkStrengthIcon;
    case 3:
      return LowNetworkStrengthIcon;
    default:
      return MissingNetworkStrengthIcon;
  }
};
